import { createApi } from "@reduxjs/toolkit/query/react";
import type { ListAdminSubBrandsRequest, ListSubBrandsResponse } from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminSubBrandApi = createApi({
    reducerPath: "adminSubBrandApi",
    baseQuery: baseQueryAdminWithAuth,
    endpoints: builder => ({
        listAdminSubBrands: builder.query<ListSubBrandsResponse, ListAdminSubBrandsRequest>({
            query: body => ({
                url: "subbrand/list",
                method: "POST",
                body
            })
        })
    })
});

export const { useListAdminSubBrandsQuery } = adminSubBrandApi;
